import { addMessageFromHistory, addSuggestionsFromHistory, addResponse } from '../actions';
import { storage, retrieveHistory, setHistory } from '../services/storage';
import isInPrivateMode from '../services/private';

// Middleware definition
function chatHistoryMiddleware(storage) {
  return () => next => action => {
    if (!isInPrivateMode() && (
        action.type === 'ADD_MESSAGE' || 
        action.type === 'ADD_RESPONSE' || 
        action.type === 'ADD_SUGGESTED_RESPONSES' || 
        action.type === 'UPDATE_RESPONSE'
    )) {
        let chatHistory = retrieveHistory();

        // Add the message to the chat history
        if (action.type === 'ADD_MESSAGE' || action.type === 'ADD_RESPONSE') {
            let bodyText = action.type === 'ADD_MESSAGE' ? action.message : action.message.body;

            // This is a total hack to prevent duplicate messages being added to the local storage
            const found = chatHistory.find((message) => {
                if (message.message === undefined) { return false; }
                if (message.message.id !== undefined && message.message.id === action.message.id) {
                    return true;
                }
            });
            if (found) { return next(action); }

    	    chatHistory.push({
                message: {
                    id: action.message.id,
                    body: bodyText,
                    title: action.message.type === 'link' && bodyText,
                    pic_url: action.message.pic_url,
                    vid_url: action.message.vid_url,
                    type: action.message.type || "text",
                    url: action.message.linkUrl,
                    previewTitle: action.message.previewTitle,
                    previewDescription: action.message.previewDescription,
                    icon: action.message.icon
                },
                own: action.type === 'ADD_MESSAGE'
    	    });

        } else if (action.type === 'ADD_SUGGESTED_RESPONSES') {
            let suggestedResponses = action.messages.map(message => {
                return {
                    body: message.body,
                    responseId: message.response_id,
                    type: message.type
                }
            });

            let suggestedResponsesIndex = chatHistory.map((obj, index) => {
                return obj.suggestedResponses && index;
            }).filter(val => !!val)[0];

            if(suggestedResponsesIndex && suggestedResponsesIndex != -1) {
                chatHistory.splice(suggestedResponsesIndex, 1);
            }

            chatHistory.push({
                suggestedResponses: suggestedResponses
            });
        } else if (action.type === 'UPDATE_RESPONSE') {
            let element = chatHistory.find(object => {
                return object.message.id === action.message.id
            });

            element.message = action.message;
        }

        setHistory(chatHistory);
    }

        return next(action);
    };
}

const chatHistoryMiddlewareThunk = chatHistoryMiddleware();
chatHistoryMiddlewareThunk.withExtraArgument = chatHistoryMiddleware;

export default chatHistoryMiddlewareThunk;


// Rebuild messages from local storage
export function rebuildMessagesFromHistory(store) {
    const chatHistory = retrieveHistory();

    if(chatHistory instanceof Array) {
        chatHistory.forEach(historyItem => {
            if (historyItem.message) {
                store.dispatch(addMessageFromHistory(historyItem));
            } else if (historyItem.suggestedResponses) {
                store.dispatch(addSuggestionsFromHistory(historyItem));
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/history.js